<template>
    <div>
        <v-btn block
               variant="flat"
               size="small"
               color="grey-lighten-2"
               @click="open">
            Recalculate Estimate
        </v-btn>
        <v-dialog v-model="show"
                  width="auto"
                  persistent>
            <v-card width="700">
                <v-form @submit.prevent="recalculate" :disabled="loading">
                    <v-card-title class="d-flex justify-space-between align-center">
                        <div class="ps-2">Recalculate Time & Powder Estimates</div>
                        <v-btn icon="mdi-close"
                               variant="text"
                               @click="show = false"></v-btn>
                    </v-card-title>
                    <v-card-subtitle class="text-wrap">
                        Make the total be just for powdercoating line items, exclude any non-line items like blasting, stripping, surcharges etc.
                    </v-card-subtitle>
                    <v-card-text>
                        <v-table density="compact" class="text-caption">
                            <thead>
                                <tr>
                                    <th class="w-10"></th>
                                    <th>Description</th>
                                    <th class="text-right">Qty</th>
                                    <th class="text-right">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item.id">
                                    <td>
                                        <v-checkbox v-model="item.included"
                                                    hide-details
                                                    density="compact"
                                                    @update:modelValue="toggleItem(item)"></v-checkbox>
                                    </td>
                                    <td>{{ item.description }}</td>
                                    <td class="text-right">{{ numberWithCommas(item.quantity, 2) }}</td>
                                    <td class="text-right">${{ numberWithCommas(item.subTotalAmount, 2) }}</td>
                                </tr>
                            </tbody>
                        </v-table>
                        <v-text-field v-model.number="total"
                                      class="mt-4"
                                      type="number"
                                      min="0"
                                      step="0.01"
                                      prefix="$"
                                      label="Estimate Total (ex GST)"
                                      hint="Unticking a line removes it from this total, or enter a total directly"
                                      persistent-hint></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn :loading="loading"
                               type="submit"
                               :disabled="!valid"
                               flat
                               color="primary"
                               prepend-icon="mdi-calculator-variant-outline">RECALCULATE</v-btn>
                        <v-btn flat class="ml-2" @click="resetItems">RESET</v-btn>
                        <v-btn flat class="ml-2" @click="show = false">CANCEL</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import { mapActions, mapMutations } from "vuex";
    import { numberWithCommas } from "../../mixins/numberMixins";
    function initialState() {
        return {
            show: false,
            loading: false,
            items: [],
            total: null
        };
    }
    export default {
        name: "RecalculateLineTimeEstimate",
        data: function () {
            return initialState();
        },
        props: {
            job: Object
        },
        methods: {
            numberWithCommas,
            ...mapMutations([
                "setEntityRecord"
            ]),
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
            round(value) {
                return Math.round(value * 100) / 100;
            },
            open() {
                this.resetItems();
                // Prepopulate with the previously saved custom total
                if (this.job.estimateSubTotal != null) {
                    this.total = this.round(this.job.estimateSubTotal);
                }
                this.show = true;
            },
            resetItems() {
                this.items = (this.job.jobItems || []).map(item => ({
                    id: item.id,
                    description: item.description,
                    quantity: item.quantity,
                    subTotalAmount: item.subTotalAmount || 0,
                    included: true
                }));
                this.total = this.round(this.items.reduce((sum, item) => sum + item.subTotalAmount, 0));
            },
            toggleItem(item) {
                let current = Number(this.total) || 0;
                this.total = this.round(item.included ? current + item.subTotalAmount : current - item.subTotalAmount);
            },
            recalculate() {
                if (!this.valid) {
                    return;
                }
                this.loading = true;
                this.$api.post(this.$constants.entities.Job.ROUTE + 'recalculateestimate', {
                    id: this.job.id,
                    estimateSubTotal: this.total
                }).then(res => {
                    this.loading = false;
                    this.setEntityRecord(res.data);
                    this.showSuccessSnack('Estimates recalculated');
                    this.show = false;
                }).catch(error => {
                    this.loading = false;
                    this.showErrorSnack('There was an issue recalculating the estimates.');
                });
            }
        },
        computed: {
            valid() {
                return this.total !== null && this.total !== '' && !isNaN(this.total) && Number(this.total) >= 0;
            }
        }
    };
</script>
